<
<template>
  <div>
    <component-header
      title="Notification Approval Details"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/approvalNotification')"
    />
    <b-card>
      <div>
        <h4 style="text-align: right; margin-right:120px">
          Status :
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'APPROVED'"
            style="color: green; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'REJECTED'"
            style="color: red; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'PENDING'"
            style="color: blue; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
        </h4>
      </div>
      <div>
        <b-row>
          <b-col md="8" class="pb-0"
            ><h4 class="mx-3" style="color: var(--primary)">Filter Criteria</h4></b-col
          >
          <b-col md="4" class="pb-0"
            ><h4 class="mx-3" style="color: var(--primary)">Search Criteria</h4></b-col
          >
        </b-row>
        <b-row class="mt-0">
          <b-col md="5" class="mt-2">
          <div class="mx-3">
           <div class="d-flex align-items-center mb-2">
               <label class="text-dark font-weight-bold " style="min-width: 130px;">
               Created Date:
              </label>
             <input type="text" class="form-control " v-model="bulkNotificationData.createdAt" />
           </div>
           <div class="d-flex align-items-center mb-2">
              <label class="text-dark font-weight-bold " style="min-width: 130px;">
              Collection Name:
              </label>
             <input type="text" class="form-control " v-model="bulkNotificationData.criteria.collectionName" />
           </div>
           <div class="d-flex align-items-center mb-2">
              <label class="text-dark font-weight-bold " style="min-width: 130px;">
              Count:
              </label>
             <input type="number" class="form-control" v-model="bulkNotificationData.criteria.count" />
           </div>
          <div class="d-flex align-items-center mb-2">
            <label class="text-dark font-weight-bold " style="min-width: 130px;">
             Status:
           </label>
            <input type="text" class="form-control " v-model="bulkNotificationData.criteria.status" />
          </div>
          <div class="d-flex align-items-center mb-2">
         <label class="text-dark font-weight-bold" style="min-width: 130px;">
          URL:
        </label>
        <a
         :href="bulkNotificationData && bulkNotificationData.criteria ? bulkNotificationData.criteria.url : ''"
         class="btn btn-primary  w-100"
         target="_blank"
         rel="noopener noreferrer"
        >
        Download
        </a>
      </div>
         </div>
          </b-col>
          <b-col md="7">
            <b-table
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="approvalNotificationFilter"
              :fields="criteriaColumns"
              thead-class="header"
              show-empty
            >
            <template #cell(name)="data">
              <b class="text-info">{{ data.value.last.toUpperCase() }}</b>, <b>{{ data.value.first }}</b>
            </template>
            </b-table>
            <!-- <div class="mx-3">
              <h5 class="h5-text">
                Value :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0] &&
                  bulkNotificationData.criteria.filterBy[0].data
                    ? bulkNotificationData.criteria.filterBy[0].data.value
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Field :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0]
                    ? bulkNotificationData.criteria.filterBy[0].field
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Filter :
                <span class="span-text">{{
                  bulkNotificationData &&
                  bulkNotificationData.criteria &&
                  bulkNotificationData.criteria.filterBy[0]
                    ? bulkNotificationData.criteria.filterBy[0].filter
                    : ""
                }}</span>
              </h5> 
            </div> -->
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed var(--primary)" class="mt-2 my-3" />
       <h4 class="mx-3" style="color: var(--primary)">Template Configuration</h4>
<b-row>
  <b-col md="4">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Description :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.description"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Notification Type :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.notificationType"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Schedule Date & Time :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.scheduleDate | formateScheduleDate"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Scheduler Status :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.schedulerStatus"
        />
      </div>
    </div>
  </b-col>

  <b-col md="4">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Status :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData.status"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Concern :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.concern : ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Name :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.name : ''"
        />
      </div>
    </div>
  </b-col>

  <b-col md="4">
    <div class="mx-3">
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Notification Pending :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.pending || ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Notification Success :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.success || ''"
        />
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Notification Failed :</label>
        <input
          type="text"
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.jobStatus && bulkNotificationData.jobStatus.failed || ''"
        />
      </div>
    </div>
  </b-col>

  <b-col md="12">
    <div class="mx-3">
      <div class="d-flex align-items-start mb-2">
        <label class="text-dark font-weight-bold mr-2" style="min-width: 100px;">Body :</label>
        <textarea
          class="form-control"
          :value="bulkNotificationData && bulkNotificationData.template ? bulkNotificationData.template.body : ''"
        ></textarea>
      </div>
    </div>
  </b-col>
</b-row>
        <div
          class="text-center mb-5 mt-2 p-4"
          v-if="bulkNotificationData.status === 'PENDING'"
        >
          <button
            type="button"
            class="btn btn-lg btn-outline-danger mr-3 w-25"
            @click="approvalStatus(bulkNotificationData._id, 'REJECTED')"
          >
            REJECT
          </button>
          <button
            type="button"
            class="btn btn-lg btn-outline-success ml-3 w-25"
            @click="approvalStatus(bulkNotificationData._id, 'APPROVED')"
          >
            APPROVE
          </button>
        </div>
        <div class="text-center mb-5 mt-3" v-else>
          <button
            type="button"
            class="btn btn-sm btn-primary mr-3"
            :disabled="true"
          >
            {{ bulkNotificationData.status }}
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import currentUser from "@/mixins/currentUser";

export default {
  name: "approvalNotificationDetails",
  components: {
    ComponentHeader,
  },
  data() {
    return {
      isloading: false,
      bulkNotificationData: [],
      small: false,
      fixed: false,
      bordered: true,
      striped: false,
      criteriaColumns: [
        {
          key: "field",
          label: "Field",
        },
        {
          key: "filter",
          label: "Filter",
          sortable: true,
        },
        {
          key: "value.value",
          label: "Value",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      GetFetchBulkNotificationList:
        "approvalNotificationBulk/GetFetchBulkNotificationList",
    }),
    approvalNotificationList() {
      return this.GetFetchBulkNotificationList;
    },
    approvalNotificationFilter() {
      const allFilter = this.bulkNotificationData?.criteria?.filterBy?.map(
        (criteria) => {
          if (criteria.filter !== "date") {
            let showData = {
              value: criteria.data,
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          } else {
            let showData = {
              value: {value: `${criteria.data.gte} To ${criteria.data.lte}`},
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          }
        }
      );
      return allFilter;
    },
  },

  methods: {
    async approvalStatus(id, status) {
      let payload = {
        id: id,
        status: status,
      };
      await this.$store
        .dispatch("approvalNotificationBulk/updateApprovalNoti", payload)
        .then((data) => {
          if (data.status === 1) {
            this.bulkNotificationData = {};
            this.$swal({
              title: "Success",
              text: `Approval Request ${status}`,
              type: "success",
            });
            this.$router.push("/approvalNotification");
          }
        })
        .catch((e) => {});
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
    formateScheduleDate: function (value) {
      if (value) {
        let duration = moment.duration({hours: 5, minutes: 30})
        return moment(String(value)).subtract(duration).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
  mounted: async function () {
    this.loading = true;
    let payload = {
      status: "",
      fromDate: "",
      toDate: "",
    };
    await this.$store.dispatch(
      "approvalNotificationBulk/fetchBulkNotificationList",
      payload
    );
    this.bulkNotificationData = await this.approvalNotificationList.find(
      (data) => this.$route.params.id === data._id
    );
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: var(--primary) !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: var(--primary) !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
>
